import { render, staticRenderFns } from "./homeworks-full.vue?vue&type=template&id=a5229fd0&scoped=true&"
import script from "./homeworks-full.vue?vue&type=script&lang=js&"
export * from "./homeworks-full.vue?vue&type=script&lang=js&"
import style0 from "./homeworks-full.vue?vue&type=style&index=0&id=a5229fd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5229fd0",
  null
  
)

export default component.exports